import { Box, Flex } from '@chakra-ui/react';
import { FORECAST_COLUMNS } from './columns';

export const ForecastHeader: React.FC = () => {
  return (
    <Flex
      fontWeight="bold"
      textAlign={{ lg: 'right', xl: 'left' }}
      whiteSpace="nowrap"
      bg="surface.sidebarMuted"
      flexDir="row"
      wrap="nowrap"
      minW="fit-content">
      {FORECAST_COLUMNS.map((col) => (
        <Box
          key={col.key}
          fontSize={{ md: 'xs', lg: 'sm' }}
          textAlign={{ lg: 'right', xl: 'left' }}
          fontWeight="medium"
          fontFamily="marketingPage"
          color="content.muted"
          width={col.width}
          minW={col.minW}
          p={4}>
          {col.label}
        </Box>
      ))}
    </Flex>
  );
};
